import maxBy from 'lodash/maxBy';
import { domain } from 'modules/data';
import { useMemo } from 'react';

export const useGetRecognizedOcrAttachment = (request: domain.Request) => {
    return useMemo(() => {
        return maxBy(
            request.attachments.filter((attachment) => attachment.ocrStatus === domain.OcrStatus.Succeeded),
            (attachment) => (attachment.createdDate ? new Date(attachment.createdDate).getTime() : 0)
        );
    }, [request.attachments]);
};
